import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import "./offline.scss"

const Offline = () => {

    return (
        <div className="offline">
            <Helmet>
                <title>Offline</title>
            </Helmet>
            <div className="container">
                <div className="left">
                    <div className="box">
                        <h5>CONNECTION LOST</h5>
                    </div>
                    <h2>Ups! Keine Internetverbindung.</h2>
                    <p>Leider konnten wir keine Verbindung zum Internet herstellen.</p>
                    <Link to="/">
                        <button>Erneut versuchen</button>
                    </Link>
                </div>
                <div className="symbol">
                    <div className="circle">
                        <WifiOffOutlinedIcon />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Offline